import styled from 'styled-components';
import { breakpointUp } from '../../../styles/mediaUtils';
import { typeScale } from '../../../styles/newTypography';
import { spacing } from '../../../styles/newThemeVariables.styles';
import { Grid } from '../../layout/Grid';

export const Container = styled(Grid)``;

export const Header = styled.header`
  grid-column: span 2;
  padding: ${spacing.space160} 0 ${spacing.space56} 0;

  @media ${breakpointUp.tablet} {
    grid-column: span 7;
    padding: ${spacing.space200} 0 ${spacing.space72} 0;
  }

  @media ${breakpointUp.desktop} {
    grid-column: span 6;
    padding: ${spacing.space250} 0 ${spacing.space72} 0;
  }

  @media ${breakpointUp.desktopLarge} {
    grid-column: span 5;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.textPrimary};
  text-wrap: balance;
  margin: 0;
  ${typeScale.mobile.body.xxl};

  @media ${breakpointUp.tablet} {
    ${typeScale.tablet.body.xxxl};
  }

  @media ${breakpointUp.desktop} {
    ${typeScale.desktop.body.xxxl};
  }

  @media ${breakpointUp.desktopLarge} {
    ${typeScale.desktop.body.xxxxl};
  }
`;
